import React from "react";
import { PropTypes } from 'prop-types';
import AccountName from "./Components/AccountName";
import LegacyOptions from "./Components/LegacyOptions/LegacyOptions";
import { connect } from "react-redux";
import { Row } from "antd";
import { withRouter } from "react-router-dom";
import {
  setLegacyValues,
  updateActivePageStepName
} from "../actions";
import { updateActivePageStepNumber, updatePageStepToProcess, updateStepperAllToFinish } from "../../../../actions/globalActions";
import { basicStepperConfig } from '../DefaultPropTypes';
import { StepTwoMainStates } from "../selectors";

export class Step2Main extends React.Component {
  componentWillMount() {
    if(this.props.legacy === undefined ) {
      this.props.setLegacyValues();
    } 
    
    this.props.setActivePageStepNumber(2);
    this.props.setActivePageStepName("step2Legacy");
    this.updateStepper();
  }
  updateStepper(){
    let stepperConfig = [
      {
        key: 1,
        description: 'Provide account information',
        status: 'finish',
        route: '/open-an-additional-account/account-information/',
        pageName: 'step1Setup',
      },
      {
        key: 2,
        description: 'Legacy options',
        status: "process",
        route: '/open-an-additional-account/legacy-options/',
        pageName: 'step2Legacy',
      },
      {
        key: 3,
        description: 'Review and Submit',
        status: "wait",
        route: '/open-an-additional-account/review/',
        pageName: 'step3Review',
      },
    ];
    this.props.updateStepperAllToFinish(stepperConfig);
  }

  subHeadingContent =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.";
  mainHeading = "Set up your additional account";
  render() {
    return (
      <div>
        <Row>
          <AccountName />
          <LegacyOptions contentType={"sub_headings_desc_legacy_options"} page={'Legacy options'} />
        </Row>
      </div>
    );
  }
}

Step2Main.propTypes = {
  id: PropTypes.string, 
  activePageStepNumber: PropTypes.number, 
  history: PropTypes.object, 
  legacy: PropTypes.any, 
  location: PropTypes.object, 
  match: PropTypes.object, 
  processActivePageStep: PropTypes.func, 
  setActivePageStepName: PropTypes.func, 
  setActivePageStepNumber: PropTypes.func, 
  setLegacyValues: PropTypes.func, 
  staticContext: PropTypes.any, 
  stepperConfig: basicStepperConfig, 
  updateStepperAllToFinish: PropTypes.func, 
}

const mapStateToProps = state => ({
  ...StepTwoMainStates(state.toJS())
})

const mapDispatchToProps = dispatch => ({
  setLegacyValues: val => dispatch(setLegacyValues(val)),
  setActivePageStepNumber: stepNumber =>
    dispatch(updateActivePageStepNumber(stepNumber)),
  setActivePageStepName: stepName => dispatch(updateActivePageStepName(stepName)),
  processActivePageStep: () => dispatch(updatePageStepToProcess()),
  updateStepperAllToFinish: (data) => dispatch(updateStepperAllToFinish(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Step2Main)
);
